// Download/connect modal — native <dialog>, content verbatim from the
// legacy #download modal (register → download client → manual connect).
import { useEffect, useRef } from "react";

interface DownloadModalProps {
  readonly open: boolean;
  readonly onClose: () => void;
}

export function DownloadModal({ open, onClose }: DownloadModalProps) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dlg = ref.current;
    if (!dlg) return;
    if (open && !dlg.open) dlg.showModal();
    if (!open && dlg.open) dlg.close();
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      // Same ESC safety net as the lightbox — no-op where the UA already
      // closed the dialog natively.
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <dialog
      ref={ref}
      className="wv-h2-modal"
      onClose={onClose}
      onClick={(e) => {
        // Backdrop click: dialog element itself is the click target only
        // when clicking outside its content box.
        if (e.target === ref.current) onClose();
      }}
    >
      <div className="wv-h2-modal-body">
        <button className="wv-h2-modal-close" onClick={onClose} aria-label="关闭">
          ×
        </button>
        <h3>
          <span className="thin">开始 游戏</span>
        </h3>
        <h4>0.首先，你需要点击下面的链接注册随便~MC并申请白名单</h4>
        <a className="wv-h2-btn wv-h2-btn--info wv-h2-btn--lg" href="/register">
          点击这里注册并申请白名单
        </a>
        <hr />
        <h4>1.点击下面按钮下载MC的官方客户端！</h4>
        <a
          className="wv-h2-btn wv-h2-btn--info wv-h2-btn--lg"
          target="_blank"
          rel="noreferrer"
          href="https://www.minecraft.net/zh-hans/download"
        >
          下载 Minecraft
        </a>
        <hr />
        <h4>2.已经有了其他客户端？可以直接手动连接</h4>
        <div className="wv-h2-modal-addrs">
          <p>多线：<code>evermc.net</code></p>
        </div>
      </div>
    </dialog>
  );
}
